<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <div class="">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10 pt-4">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo bold">Administración</span>
                </div>
                <div class="col-6 col-md-6">
                  <button
                    class="btngris float-right"
                    @click="definirPolizaGlobal"
                  >
                    Definir No. Póliza Global
                  </button>
                </div>
              </div>

              <div class="contenido">
                <div class="row">
                  <div class="col-12" v-if="this.data != null">
                    <div class="row">
                      <div class="col-12 pb-4">
                        Mes corriente:
                        <span class="bold"
                          >{{ meses[mes_corriente - 1] }}
                          {{ ano_corriente }}</span
                        >
                      </div>
                      <div class="col-12 pb-4">
                        Póliza corriente:
                        <span class="bold">{{ no_poliza }}</span>
                      </div>
                    </div>

                    <v-client-table
                      :columns="columns"
                      v-model="data"
                      :options="options"
                    >
                      <a slot="user_level" slot-scope="props">
                        <span v-if="props.row.user_level == 1"
                          >Administrador</span
                        >
                        <span v-if="props.row.user_level == 10">Básico</span>
                      </a>

                      <div
                        slot="uri"
                        slot-scope="props"
                        class="text-left negro pointer"
                      >
                        <router-link :to="'/configuracion/' + props.row.id">
                          <i class="fas fa-cogs"></i> Configuración
                        </router-link>
                      </div>

                      <!-- <div
                        slot="uri2"
                        slot-scope="props"
                        @click="
                          defineCoberturaBasica(props.row.id, props.row.contratante)
                        "
                        class="text-left negro pointer"
                      >
                        <i class="fas fa-edit"></i> Definir Cobertura Básica
                      </div> -->

                      <div
                        slot="name"
                        slot-scope="{
                          row,
                          update,
                          setEditing,
                          isEditing,
                          revertValue,
                        }"
                      >
                        <span @click="setEditing(true)" v-if="!isEditing()">
                          <a>{{ row.name }}</a>
                        </span>
                        <span v-else>
                          <input type="text" v-model="row.name" />
                          <button
                            type="button"
                            class="btn btn-info btn-xs"
                            @click="
                              update(row.name);
                              setEditing(false);
                            "
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            class="btn btn-default btn-xs"
                            @click="
                              revertValue();
                              setEditing(false);
                            "
                          >
                            Cancel
                          </button>
                        </span>
                      </div>
                    </v-client-table>
                  </div>
                </div>

                <span
                  class="loading"
                  v-bind:class="{ active: this.$store.state.loading }"
                >
                  <img
                    src="../assets/imgs/DualRing-1.1s-28px.svg"
                    alt="loading"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="overlay" v-if="showOverlay">
      <div class="overlaybg" @click="toggleOverlay"></div>
      <div class="overlayinfo">
        <div class="cont container">
          <div class="row card bg-white shadow round">
            <div class="btnclose" @click="toggleOverlay">
              <i class="fa fa-times"></i>
            </div>

            <div class="col-12 p-4">
              <h2 class="text-center">Generación de No. de Póliza Global</h2>
              <hr />
              <form
                class="formulario"
                action=""
                @submit="submitNoPoliza($event)"
              >
                <label>
                  <span>No. de Póliza</span>
                  <input type="text" v-model="form.no_poliza" required />
                </label>
                <div class="row pb-4">
                  <div class="col-6">
                    <label>
                      <span>Mes</span>
                      <select v-model="form.mes" required>
                        <option value="">Mes</option>
                        <option value="1">Enero</option>
                        <option value="2">Febrero</option>
                        <option value="3">Marzo</option>
                        <option value="4">Abril</option>
                        <option value="5">Mayo</option>
                        <option value="6">Junio</option>
                        <option value="7">Julio</option>
                        <option value="8">Agosto</option>
                        <option value="9">Septiembre</option>
                        <option value="10">Octubre</option>
                        <option value="11">Noviembre</option>
                        <option value="12">Diciembre</option>
                      </select>
                    </label>
                  </div>
                  <div class="col-6">
                    <label>
                      <span>Año</span>
                      <select v-model="form.ano" required>
                        <option value="">Año</option>
                        <option value="2021">2021</option>
                        <option value="2022">2022</option>
                        <option value="2023">2023</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                        <option value="2027">2027</option>
                        <option value="2028">2028</option>
                        <option value="2029">2029</option>
                        <option value="2030">2030</option>
                        <option value="2031">2031</option>
                        <option value="2032">2032</option>
                        <option value="2033">2033</option>
                        <option value="2034">2034</option>
                        <option value="2035">2035</option>
                        <option value="2036">2036</option>
                        <option value="2037">2037</option>
                        <option value="2038">2038</option>
                        <option value="2039">2039</option>
                        <option value="2040">2040</option>
                        <option value="2041">2041</option>
                        <option value="2042">2042</option>
                        <option value="2043">2043</option>
                        <option value="2044">2044</option>
                        <option value="2045">2045</option>
                        <option value="2046">2046</option>
                        <option value="2047">2047</option>
                        <option value="2048">2048</option>
                        <option value="2049">2049</option>
                        <option value="2050">2050</option>
                        <option value="2051">2051</option>
                        <option value="2052">2052</option>
                        <option value="2053">2053</option>
                        <option value="2054">2054</option>
                        <option value="2055">2055</option>
                        <option value="2056">2056</option>
                        <option value="2057">2057</option>
                        <option value="2058">2058</option>
                        <option value="2059">2059</option>
                        <option value="2060">2060</option>
                        <option value="2061">2061</option>
                        <option value="2062">2062</option>
                        <option value="2063">2063</option>
                        <option value="2064">2064</option>
                        <option value="2065">2065</option>
                        <option value="2066">2066</option>
                        <option value="2067">2067</option>
                        <option value="2068">2068</option>
                        <option value="2069">2069</option>
                        <option value="2070">2070</option>
                        <option value="2071">2071</option>
                        <option value="2072">2072</option>
                        <option value="2073">2073</option>
                        <option value="2074">2074</option>
                        <option value="2075">2075</option>
                        <option value="2076">2076</option>
                        <option value="2077">2077</option>
                        <option value="2078">2078</option>
                        <option value="2079">2079</option>
                        <option value="2080">2080</option>
                        <option value="2081">2081</option>
                        <option value="2082">2082</option>
                        <option value="2083">2083</option>
                        <option value="2084">2084</option>
                        <option value="2085">2085</option>
                        <option value="2086">2086</option>
                        <option value="2087">2087</option>
                        <option value="2088">2088</option>
                        <option value="2089">2089</option>
                        <option value="2090">2090</option>
                        <option value="2091">2091</option>
                        <option value="2092">2092</option>
                        <option value="2093">2093</option>
                        <option value="2094">2094</option>
                        <option value="2095">2095</option>
                        <option value="2096">2096</option>
                        <option value="2097">2097</option>
                        <option value="2098">2098</option>
                        <option value="2099">2099</option>
                      </select>
                    </label>
                  </div>
                </div>
                <label class="w-100 text-center">
                  <button class="btn btngris m-auto text-center" type="submit">
                    Enviar
                  </button>
                </label>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="overlay" v-if="showOverlay2">
      <div class="overlaybg" @click="toggleOverlay2"></div>
      <div class="overlayinfo">
        <div class="cont container">
          <div class="row card bg-white shadow round">
            <div class="btnclose" @click="toggleOverlay2">
              <i class="fa fa-times"></i>
            </div>

            <div class="col-12 p-4">
              <h2 class="text-center">
                % Cobertura Básica para {{ form.nombre_contratante }}
              </h2>
              <hr />
              <form
                class="formulario"
                action=""
                @submit="submitCoberturaBasica($event)"
              >
                <label>
                  <span>% de Cobertura Básica</span>
                  <input
                    type="number"
                    v-model="form.cobertura_basica"
                    required
                  />
                </label>

                <label class="w-100 text-center">
                  <button class="btn btngris m-auto text-center" type="submit">
                    Enviar
                  </button>
                </label>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import moment from "moment";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      no_poliza: "",
      tiposervicio: "",
      showOverlay: false,
      showOverlay2: false,
      form: {
        user_id: "",
        nombre_contratante: "",
        no_poliza: "",
        cobertura_basica: "",
        mes: "",
        ano: "",
      },
      mes_corriente: "",
      ano_corriente: "",
      meses: [
        "Enero",
        "Feberero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      columns: [
        "uri",
        //"uri2",
        "contratante",
        "user_email",
        //"no_poliza",
        "cobertura_basica",
        "nombre",
        "apellido_paterno",
        "apellido_materno",
        //"user_level",

        //"uri",
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 25,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          uri: "Acción",
          uri2: "Acción",
          user_email: "Email",
          //no_poliza: "No. de Póliza Vigente",
          cobertura_basica: "% Cobertura Básica",
          nombre: "Nombre",
          email: "Email",
          user_level: "Nivel",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [
          "contratante",
          "user_email",
          //"no_poliza",
          "cobertura_basica",
          "nombre",
          "apellido_paterno",
          "apellido_materno",
          "user_level",
        ],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} usuarios|{count} usuarios|Un usuario",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar usuario",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
    AOS.init();

    this.consulta();
    this.getNoPolizaVigente();
  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {};

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log({ qData: JSON.stringify(qData) });

      this.$http
        .post(
          vm.$store.state.baseurl + "consulta-usuarios-admins.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos;
              this.mes_corriente = res.mes;
              this.ano_corriente = res.ano;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitNoPoliza(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = this.form;

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(qData));
      //formData.append("cv", this.file);

      console.log("enviando");
      //console.log(this.file);
      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "actualiza-no-poliza.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //
              this.toggleOverlay();
              swal.fire("Bien", res.msg, "success");
              window.location.reload();
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitCoberturaBasica(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = this.form;

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(qData));
      //formData.append("cv", this.file);

      console.log("enviando");
      //console.log(this.file);
      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "actualiza-cobertura-basica.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //
              this.toggleOverlay2();
              swal.fire("Bien", res.msg, "success");
              window.location.reload();
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    defineNoPoliza(user_id, nombre_contratante) {
      this.form.user_id = user_id;
      this.form.nombre_contratante = nombre_contratante;

      this.toggleOverlay();
    },
    definirPolizaGlobal(user_id, nombre_contratante) {
      console.log("definiendo poliza global");
      this.form.user_id = this.$store.state.user;
      this.form.nombre_contratante = this.$store.state.user.nombre;

      this.toggleOverlay();
    },
    defineCoberturaBasica(user_id, nombre_contratante) {
      console.log({ user_id });
      this.form.user_id = user_id;
      this.form.nombre_contratante = nombre_contratante;

      this.toggleOverlay2();
    },
    toggleOverlay() {
      this.showOverlay = !this.showOverlay;
    },
    toggleOverlay2() {
      this.showOverlay2 = !this.showOverlay2;
    },
    getNoPolizaVigente() {
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.form;
      qData.user_email = this.$store.state.user.user_email;

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "get-no-poliza-vigente.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              this.no_poliza = res.no_poliza;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
  },
};
</script>

